import _compact from "lodash/compact";
import {
    GATrackCartAction,
    GATrackCartActionType,
    GATrackCheckoutAndNavigateAction,
    GATrackFunnelEventAndNavigateAction,
    GATrackRefillCheckoutAndNavigateAction,
} from "./actionTypes";
import { FunnelEvent, ICartItem } from "../../../../models";
import { State as CheckoutState } from "../../checkout/state/selectors";

export const trackCheckout: (step: number, initiatedBy: string) => GATrackCheckoutAndNavigateAction = (
    step,
    initiatedBy,
) => ({
    type: "TRACKING_CHECKOUT",
    payload: {
        step,
        initiatedBy,
    },
});

export const trackCheckoutAndNavigate: (step: number, url: string) => GATrackCheckoutAndNavigateAction = (
    step,
    url,
) => ({
    type: "TRACKING_CHECKOUT",
    payload: {
        step,
        url,
    },
});

export const trackRefillCheckoutAndNavigate: (step: number, url: string) => GATrackRefillCheckoutAndNavigateAction = (
    step,
    url,
) => ({
    type: "TRACKING_REFILL_CHECKOUT",
    payload: {
        step,
        url,
    },
});

export const trackFunnelEventAndNavigate: (
    trackingObj: FunnelEvent,
    url: string,
) => GATrackFunnelEventAndNavigateAction = (trackingObj, url) => ({
    type: "TRACKING_FUNNEL",
    payload: {
        trackingObj,
        url,
    },
});

export const getCartTrackingAction: <T extends GATrackCartActionType>(
    state: CheckoutState,
    type: T,
    ...products: (ICartItem | undefined)[]
) => GATrackCartAction<T> = (state, type, ...products) => ({
    type,
    payload: {
        state: {
            ...state,
            checkout: {
                ...state.checkout,
                cart: {
                    content: _compact(products),
                },
            },
        },
    },
});
